import { faAnchor } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import { INSERT_MEDIA_COMMAND } from "../../MediaPlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useIntl } from "react-intl";

export function ExternalMedia()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const handleClick = () => editor.dispatchCommand(INSERT_MEDIA_COMMAND, 'https://www.youtube.com/watch?v=abcdefghijk');
    const element = <ToolbarButton title={translations?.insertExternalMedia ?? 'Insert external media'} icon={faAnchor} onClick={handleClick} />;
    return element;
}